import script from "./ContactDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactDetail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__